import { type Country } from "../types/types";

type PostalCodeMatchers = Partial<{ [key in Country]: string }>;

export const postalCodeMatchers: PostalCodeMatchers = {
  US: "(^\\d{5}-?$)|(^\\d{5}-\\d{4}$)",
  AU: "^\\d{4}$",
  CA: "^[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z] ?\\d[ABCEGHJ-NPRSTV-Z]\\d$",
  FR: "^\\d{2} ?\\d{3}$",
  DE: "^\\d{5}$",
  IT: "^\\d{5}$",
  MX: "^\\d{5}$",
  NL: "^\\d{4} ?[A-Z]{2}$",
  ES: "^\\d{5}$",
  GB: "^GIR ?0AA|(?:(?:AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|BX|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(?:\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}))|BFPO ?\\d{1,4}$",
};
